import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { ReminderPersonnelAccessManipulationView } from "./reminderPersonnelAccessManipulation-view"
import { WarehouseMultiSelectorViewModel } from "src/Warehouse/warehouseManipulation/warehouseManipulation-viewModel";
import { DistrictMultiSelectorViewModel } from "../districtManipulation/districtSelector";

export class ReminderPersonnelAccessManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت دسترسی یادآوری پرسنل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        
        this.personnels = ObservableArray.create<ReminderPersonnelAccess>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new ReminderPersonnelAccessManipulationView();
    }
    public getTypeId(): string {
        return "VM-D01C67E4-87FD-4781-9861-2B73027A5506"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set personnels(v: ObservableArray<ReminderPersonnelAccess>) { this._personnels = v; } public get personnels(): ObservableArray<ReminderPersonnelAccess> { return this._personnels;} private _personnels: ObservableArray<ReminderPersonnelAccess>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
        
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelAccessServices/GetAllReminderPersonnelAccesses',{
                FurtherQueryInfo:filteringInformation
            });
            this.personnels.update(...result.Accesses.map(x=>{
                let r = new ReminderPersonnelAccess(this);
                r.reminderPersonnelAccessId = x.ReminderPersonnelAccessId;
                r.isDeleted = x.ReminderPersonnelAccessId == null;
                r.personnelId = x.PersonnelId;
                r.personnelCode = x.PersonnelCode;
                r.personnelFullName = x.PersonnelFullName;
                r.isFinancial = x.IsFinancial;
                r.isManager = x.IsManager;
                r.districts = x.Districts;
                r.warehouses = x.Warehouses;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    
    async personnelUpdater(personnel:ReminderPersonnelAccess){
        let editor = new ReminderPersonnelAccessEditor(this,new UpdateServerUpdater());
        editor.loadByPersonnelId(personnel.personnelId);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async remove(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/PersonnelAccessServices/RemoveReminderPersonnelAccess',{
                ReminderPersonnelAccessId:id
            });
            await this.messageBoxConfirmSuccess('دسترسی یادآوری پرسنل حذف شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class ReminderPersonnelAccess extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReminderPersonnelAccessManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.warehouseSelector = new WarehouseMultiSelectorViewModel(this, true);
        this.districtSelector = new DistrictMultiSelectorViewModel(this);
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isDeleted(v: boolean) { this._isDeleted = v; } public get isDeleted(): boolean { return this._isDeleted;} private _isDeleted: boolean;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set reminderPersonnelAccessId(v: string) { this._reminderPersonnelAccessId = v; } public get reminderPersonnelAccessId(): string { return this._reminderPersonnelAccessId;} private _reminderPersonnelAccessId: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
    public set isManager(v: boolean) { this._isManager = v; } public get isManager(): boolean { return this._isManager;} private _isManager: boolean;
    public set isFinancial(v: boolean) { this._isFinancial = v; } public get isFinancial(): boolean { return this._isFinancial;} private _isFinancial: boolean;
    public set warehouseSelector(v: WarehouseMultiSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseMultiSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseMultiSelectorViewModel;
    public set districtSelector(v: DistrictMultiSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictMultiSelectorViewModel { return this._districtSelector;} private _districtSelector: DistrictMultiSelectorViewModel;
    public set districts(v: string) { this._districts = v; } public get districts(): string { return this._districts;} private _districts: string;
    public set warehouses(v: string) { this._warehouses = v; } public get warehouses(): string { return this._warehouses;} private _warehouses: string;
    
    private _typedParent:ReminderPersonnelAccessManipulationViewModel;

    
    async edit(){
        this._typedParent.personnelUpdater(this);
    }

    async remove(){
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','حذف دسترسی یادآوری پرسنل');
        if(result=='yes'){
            this._typedParent.remove(this.reminderPersonnelAccessId);
        }
    }

}

interface IServerUpdate{
    execute(personnel:ReminderPersonnelAccess):Promise<void>;
    getSuccessMessage():string;
}


class UpdateServerUpdater implements IServerUpdate{
    
    getSuccessMessage(): string {
        return 'دسترسی یادآوری پرسنل با موفقیت به روز رسانی شد.';

    }
    async execute(personnel:ReminderPersonnelAccess): Promise<void> {
        try {
            let result =  await ServerConnection.callServer('/Complex/PersonnelAccessServices/SetReminderPersonnelAccess',{
                PersonnelId : personnel.personnelId,
                PersonnelFullName : personnel.personnelFullName,
                PersonnelCode : personnel.personnelCode,
                IsManager : personnel.isManager,
                IsFinancial : personnel.isFinancial,
                Warehouses : personnel.warehouseSelector.selectedItems.map(x=>x.id),
                Districts : personnel.districtSelector.selectedItems.map(x=>x.id),
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
        } catch (ex) {
            console.log(ex);
            throw ex;
        } finally {
        }
    }
}

export class ReminderPersonnelAccessEditor extends ReminderPersonnelAccess implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ReminderPersonnelAccessManipulationViewModel,updater : IServerUpdate) {
        super(parent);
        this.updater = updater;
    }
    closePopup(resultCode: string = null) {}

    public set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful;} private _isSuccessful: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    private updater : IServerUpdate;
    
    async loadByPersonnelId(personnelId: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelAccessServices/LoadReminderPersonnelAccess',{
                PersonnelId: personnelId
            });
            this.reminderPersonnelAccessId = result.ReminderPersonnelAccessId;
            this.personnelId = result.PersonnelId;
            this.personnelCode = result.PersonnelCode;
            this.personnelFullName = result.PersonnelFullName;
            this.isFinancial = result.IsFinancial;
            this.isManager = result.IsManager;
            this.districtSelector.selectById(result.Districts);
            this.warehouseSelector.selectById(result.Warehouses);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    verify():string[]{
        let result :string[] =[];
        
        return result;
    }    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت دسترسی یادآوری پرسنل');
                return;
            }     
            this.isLoading = true;
            await this.updater.execute(this);
            await this.messageBoxConfirmSuccess(this.updater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")         
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}


